<script>
import shiftEndDetailComponent from '@/components/shiftEndDetailComponent'
import MainLayout from '@/router/layouts/mainLayout'
export default {
  components: {
    shiftEndDetailComponent, MainLayout
  },
  data () {
    return {
      shiftId: '',
      backName: ((this.$route.query.from === 'MovementShift' || this.$route.query.from === 'VehicleList')
        ? '運行便に戻る'
        : ((this.$route.query.from === 'MovementStatus') ? '運行状況一覧に戻る' : '運行状況に戻る'))
    }
  },
  methods: {
    getShiftId (val) {
      console.log("getShiftId")
      console.log(val)
      if(val != null && val !== ""){
        this.shiftId = val
      }
    },
    editMovementWork(){
      console.log("editMovementWork")
      console.log(this.shiftId)
      this.$router.push({path: '/EditMovementWork', query:{shiftId: this.shiftId}})
    }
  }
}
</script>
<template>
<main-layout>
  <shift-end-detail-component
    :backName="backName"
    :rightTopBtnName="'運行表出力'"
    :shiftStatus= 3
    :mapBtnVisibility= true
    @transShiftID="getShiftId">
  </shift-end-detail-component>
      <div class="col-md-12 column" style="margin-top:10px; margin-bottom:10px;">
        <div style="margin:0 auto; width:25%">
          <button class="window-button-percent F2-M-24 footButton"
            style="margin-top:5px; width:100%; max-width: 500px; border-radius: 10px;"
           @click="editMovementWork()">運行実績の訂正</button>
        </div>
      </div>
</main-layout>
</template>



// WEBPACK FOOTER //
// src/router/views/ShiftEndDetail.vue